import vue from '@/main'

export default {
    SET_INSTANCES(state, instances) {
        state.instances = instances
    },
    ADD_INSTANCE(state, instance) {
        state.instances.unshift(instance)
    },
    UPDATE_INSTANCE(state, instance) {
        const instanceIndex = state.instances.findIndex((i) => i.id === instance.id)
        if (instanceIndex !== -1) {
            if (state.instances[instanceIndex].activated === true && instance.activated === false) {
                vue.$vs.notify({
                    time: 6000,
                    color: 'danger',
                    title: 'Conexão desconectada!',
                    text: `Caiu a conexão ${instance.name} que possui o `
                        + `chip ${instance.phone_number}, verifique seu celular ou tente reconectar.`
                })
            }
            Object.assign(state.instances[instanceIndex], instance)
        }
    },
    UPDATE_CHOSEN_INSTANCES(state, instance){
      const instanceIndex = state.chosenInstances.findIndex((i) => i.id === instance.id)
      if (instanceIndex !== -1) { Object.assign(state.chosenInstances[instanceIndex], instance) }
    },
    DELETE_INSTANCE(state, instanceId) {
        const ItemIndex = state.instances.findIndex((i) => i.id === instanceId)
        state.instances.splice(ItemIndex, 1)
    },
    CHOOSE_INSTANCE(state, instanceId) {
        state.selectedInstance = instanceId
    },
    CHOOSE_INSTANCE_OBJECT(state, instance) {
        state.selectedInstanceObject = instance
    },
    CHOOSE_REFRESH_INSTANCES_OBJECT(state, instance) {
        state.refreshInstancesObject = instance
    },
    CHOSEN_INSTANCES(state, instances) {
        state.chosenInstances = instances
    },
    EXISTS_CLOUD_CONNECTION(state, instances) {
        if (!state.existsCloudConnection) {
            state.existsCloudConnection = instances.findIndex((instance) => instance['is_official']) !== -1;
        }
    }
}
